import { useDispatchTrackEventWithLocation } from 'services/tracking/hooks/useDispatchTrackEventWithLocation';

export const useBulkActionsTracking = () => {
  const dispatchTrackEventWithLocation = useDispatchTrackEventWithLocation();

  const track = ({
    snapshot,
    result,
    isExport = false,
  }: {
    snapshot: { count: number; isMaster: boolean } | null;
    result: 'success' | 'failure';
    isExport?: boolean;
  }) => {
    const method = snapshot?.isMaster ? 'select all' : 'manual selection';
    const label = `${method}/${snapshot?.count || 0}/${result}`;
    dispatchTrackEventWithLocation('multi select actions', isExport ? 'export' : 'reveal', label);
  };

  return {
    handleTrackSuccessReveal: (snapshot: { count: number; isMaster: boolean } | null) =>
      track({ snapshot, result: 'success' }),

    handleTrackFailReveal: (snapshot: { count: number; isMaster: boolean } | null) =>
      track({ snapshot, result: 'failure' }),

    handleTrackSuccessExport: (snapshot: { count: number; isMaster: boolean } | null) =>
      track({ snapshot, result: 'success', isExport: true }),

    handleTrackFailExport: (snapshot: { count: number; isMaster: boolean } | null) =>
      track({ snapshot, result: 'failure', isExport: true }),

    handleTrackSuccessRevealAndExport: () =>
      dispatchTrackEventWithLocation('multi select actions', 'reveal and export', 'continue//success'),

    handleTrackFailRevealAndExport: () =>
      dispatchTrackEventWithLocation('multi select actions', 'reveal and export', 'continue//failure'),
  };
};
